import React from "react";

export default function BlogCardSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="flex items-start justify-evenly flex-col space-y-2 text-xs w-full md:min-h-[214px] h-[214px] p-4 text-gray-500 bg-white rounded-lg shadow-lg border">
        <div className="flex items-center space-x-1">
          <div className="h-4 w-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-20"></div>
        </div>
        <div className="space-y-2 w-full">
          <div className="h-6 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        </div>
        <div className="h-8 bg-gray-200 rounded w-20"></div>
      </div>
    </div>
  );
}